import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { FormInputProps } from "@/types";

export const FVEInstallation = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);

  const options = [
    {
      value: "true",
      label: t("fveData.installation.fromEON"),
    },
    {
      value: "false",
      label: t("fveData.installation.notFromEON"),
    },
  ];

  return <Select label={t("fveData.installation.label")} data={options} {...props} />;
};
